import React from 'react';
import PropTypes from 'prop-types';
import { withTranslations } from 'react-utilities';
import { translationConfig } from './translation.config';
import RecommendedGamesContainer from './containers/RecommendedGamesContainer';

function App({ translate }) {
  return <RecommendedGamesContainer translate={translate} />;
}

App.propTypes = {
  translate: PropTypes.func.isRequired
};
export default withTranslations(App, translationConfig);
